import { FunctionComponent, ReactNode, PropsWithChildren } from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface CounterHelperTextProps {
  message?: ReactNode;
  currentLength: number;
  maxLength: number | null;
  sx?: SxProps<Theme>;
}

export const CounterHelperText: FunctionComponent<PropsWithChildren<CounterHelperTextProps>> = ({
  currentLength,
  maxLength,
  message,
  sx,
}) => (
  <Box component="span" sx={{ display: 'flex', justifyContent: 'space-between', gap: '0.5rem', ...sx }}>
    <span>{message}</span>
    {maxLength && (
      <Box
        component="span"
        sx={{ color: currentLength > maxLength ? 'warning.main' : 'text.secondary' }}
      >{`${currentLength}/${maxLength}`}</Box>
    )}
  </Box>
);
